import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ProfileSearchResult} from '../../data/ProfileSearchResult';
import {EntitlementService} from '../../services/entitlement.service';
import {Ship} from '../../Ship';
import {ShipService} from '../../services/ship.service';
import {Router} from '@angular/router';
import {CardholderService} from '../../services/cardholder.service';

@Component({
  selector: 'app-cardholder-header-search',
  templateUrl: './cardholder-header-search.component.html',
  styleUrls: ['./cardholder-header-search.component.css']
})
export class CardholderHeaderSearchComponent implements OnInit {

  @Output() cardholderSelected: EventEmitter<ProfileSearchResult> = new EventEmitter();

  @Input() cardholderSearchResults: ProfileSearchResult[];
  @Input() ships: string[];

  shipName = '';
  showRecent = false;
  cardholderName = '';
  shipLocation = '';
  recentSearches: ProfileSearchResult[];

  constructor(
    private entitlementService: EntitlementService,
    private shipService: ShipService,
    private cardholderService: CardholderService,
    private router: Router
  ) {}

  ngOnInit() {
    this.recentSearches = CardholderService.retrieveAllCardholderResults();
    this.shipService.getShips().subscribe(
      (data: Ship[]) => {
        this.ships = data.map(ship => {
          return ship.shipName;
        });
      },
      () => {
        console.log('There was an error fetching ship information.');
      }
    );
  }

  hasEntitlements(entitlement) {
    return this.entitlementService.hasEntitlement(entitlement);
  }

  selectShip(shipUIC) {
    this.shipLocation = shipUIC.value;
  }

  searchCardholders() {
    if (this.cardholderName !== '') {
      this.router.navigateByUrl('/cardholderProfiles').then(() => {
        this.cardholderService.setPendingSearch(
          this.shipLocation,
          this.cardholderName
        );
      });
    }
  }

  selectCardholder(cardholder) {
    this.showRecent = !this.showRecent;
    this.cardholderSelected.emit(cardholder);
  }

}
